import React from 'react';
import { Badge, Card, Divider, Paper, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { OpenEndedResponse } from '../../types';

interface OpenEndedCommentsProps {
  responses: OpenEndedResponse[];
}

const ROLE_COLORS: Record<string, string> = {
  manager: 'blue',
  peer: 'teal',
  subordinate: 'orange',
  self: 'gray',
  other: 'gray',
};

export const OpenEndedComments: React.FC<OpenEndedCommentsProps> = ({ responses }) => {
  const { t } = useTranslation();

  return (
    <Card withBorder radius="md" p="lg">
      <Title order={4} mb="md">
        {t('review360.openEndedTitle')}
      </Title>
      {responses.length === 0 ? (
        <Text c="dimmed" ta="center" py="xl">
          {t('review360.noComments')}
        </Text>
      ) : (
        <Stack gap="lg">
          {responses.map((group, groupIdx) => (
            <Stack key={groupIdx} gap="sm">
              <Text fw={500}>{group.questionText}</Text>
              <Divider />
              <Stack gap="xs">
                {group.responses.map((resp, respIdx) => (
                  <Paper key={respIdx} withBorder p="sm" radius="sm">
                    <Stack gap={4}>
                      <Text size="sm">{resp.text}</Text>
                      <Badge
                        color={ROLE_COLORS[resp.raterRole] ?? 'gray'}
                        variant="light"
                        size="xs"
                      >
                        {t(`review360.roles.${resp.raterRole}`, resp.raterRole)}
                      </Badge>
                    </Stack>
                  </Paper>
                ))}
              </Stack>
            </Stack>
          ))}
        </Stack>
      )}
    </Card>
  );
};
